import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-715a3e40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sw-popular-tags-section--title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "sw-popular-tags-section--title-main" }, "人気のタグ"),
  /*#__PURE__*/_createElementVNode("p", { class: "sw-popular-tags-section--title-sub" }, "TAG")
], -1))
const _hoisted_3 = { class: "sw-popular-tags-section--body" }

import {
  computed,
  ref,
  onMounted,
} from 'vue';
import { Tags } from '@/api/spotwrite';
import TagService from '@/api/TagService';
import SwTagButton from '@/components/molecules/Buttons/SwTagButton.vue';

/**
 * class 属性
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'SwPopularTagsSection',
  setup(__props) {

const classes = computed(() => ({
  'sw-popular-tags-section': true,
}));

/**
 * 最新のお知らせ
 */
const tags = ref<Tags[]>([]);

const fetchData = async () => {
  const res = await TagService.popular(10);
  if (res) {
    tags.value = res;
  }
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (item) => {
          return (_openBlock(), _createBlock(SwTagButton, {
            key: item.id,
            label: item.name
          }, null, 8, ["label"]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})